import route from './src/router/index'

export default route
